(function () {
  const page = document.querySelector('[data-faq-search-page]');
  if (!page) return;

  const statusEl = page.querySelector('[data-faq-search-status]');
  const resultsEl = page.querySelector('[data-faq-search-results]');
  const emptyEl = page.querySelector('[data-faq-search-empty]');
  const template = document.querySelector('[data-faq-result-template]');
  const input = page.querySelector('[data-faq-search-input]');

  const blogHandle = page.dataset.blogHandle;
  const storefrontToken = page.dataset.storefrontToken;

  if (!blogHandle || !storefrontToken) {
    statusEl.textContent = 'Search is not configured.';
    console.error('FAQ search missing required data attributes', { blogHandle, storefrontToken: !!storefrontToken });
    return;
  }

  const params = new URLSearchParams(window.location.search);
  const rawQuery = (params.get('q') || '').trim();
  const query = sanitize(rawQuery);

  if (!query) {
    statusEl.textContent = 'Enter a search term to find help articles.';
    return;
  }

  if (input) input.value = rawQuery;

  document.title = `Search: ${rawQuery} — Help Center`;
  statusEl.textContent = `Searching for "${rawQuery}"...`;

  const graphqlQuery = `
    query SearchHelpArticles($query: String!, $blogHandle: String!) {
      blog(handle: $blogHandle) {
        articles(first: 50, query: $query) {
          edges {
            node {
              id
              title
              handle
              excerpt
              content
              tags
              onlineStoreUrl
            }
          }
        }
      }
    }
  `;

  fetch('/api/2025-07/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontToken,
    },
    body: JSON.stringify({
      query: graphqlQuery,
      variables: { query, blogHandle },
    }),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.errors) {
        console.error('GraphQL errors:', data.errors);
        showError();
        trackFaqSearch(rawQuery, 0, true);
        return;
      }

      const edges = data?.data?.blog?.articles?.edges || [];
      const articles = edges.map((edge) => edge.node);

      trackFaqSearch(rawQuery, articles.length);

      if (articles.length === 0) {
        statusEl.textContent = '';
        emptyEl.hidden = false;
        return;
      }

      statusEl.textContent = `${articles.length} result${articles.length === 1 ? '' : 's'} for "${rawQuery}"`;

      articles.forEach((article, index) => {
        const node = template.content.cloneNode(true);
        const link = node.querySelector('.faq-result__link');
        const titleEl = node.querySelector('.faq-result__title');
        const excerptEl = node.querySelector('.faq-result__excerpt');
        const tagsEl = node.querySelector('.faq-result__tags');

        const articleUrl = article.onlineStoreUrl || `/blogs/${blogHandle}/${article.handle}`;
        link.href = articleUrl;
        titleEl.textContent = article.title;

        link.addEventListener('click', () => {
          trackFaqSearchClick(rawQuery, article.title, index + 1);
        });

        let excerptText = article.excerpt || article.content || '';
        if (excerptText.trim()) {
          excerptEl.textContent = truncate(excerptText.trim(), 160);
        } else {
          excerptEl.remove();
        }

        if (tagsEl) {
          if (article.tags && article.tags.length > 0) {
            article.tags.forEach((tag) => {
              const pill = document.createElement('a');
              pill.className = 'faq-result__tag';
              pill.href = `/blogs/${blogHandle}/tagged/${encodeURIComponent(tag.toLowerCase().replace(/\s+/g, '-'))}`;
              pill.textContent = tag;
              tagsEl.appendChild(pill);
            });
          } else {
            tagsEl.remove();
          }
        }

        resultsEl.appendChild(node);
      });
    })
    .catch((err) => {
      console.error('FAQ search error:', err);
      showError();
      trackFaqSearch(rawQuery, 0, true);
    });

  function sanitize(str) {
    return str.replace(/[":()*]/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function truncate(str, n) {
    if (!str) return '';
    if (str.length <= n) return str;
    return str.slice(0, n).trim() + '…';
  }

  function showError() {
    statusEl.textContent = '';
    emptyEl.innerHTML = `<p>Search isn't available right now. <a href="/blogs/${blogHandle}">Browse all help articles</a> or <a href="https://canopy.fillout.com/contact-us">contact our team</a>.</p>`;
    emptyEl.hidden = false;
  }
function trackFaqSearch(query, resultCount, errored = false) {
    if (window.fueled && typeof window.fueled.track === 'function') {
      window.fueled.track('FAQ Searched', {
        query: query,
        result_count: resultCount,
        no_results: resultCount === 0 && !errored,
        errored: errored
      });
    }

    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'faq_search',
        faq_search_term: query,
        faq_search_results: resultCount,
        faq_no_results: resultCount === 0 && !errored,
        faq_errored: errored
      });
    }
  }

  function trackFaqSearchClick(query, articleTitle, position) {
    if (window.fueled && typeof window.fueled.track === 'function') {
      window.fueled.track('FAQ Article Clicked', {
        query: query,
        article_title: articleTitle,
        position: position
      });
    }

    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'faq_search_click',
        faq_search_term: query,
        faq_clicked_article: articleTitle,
        faq_clicked_position: position
      });
    }
  }
})();